import styled, { css } from 'styled-components'
import { Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import Button, { ButtonOption2, ButtonOption7 } from 'src/components/common/Button'
import { Container } from 'src/components/common/Container'
import { useModal } from 'src/provider/ModalContextProvider'
import usePageNav from 'src/hooks/usePageNav.hook'
import { mobileOS } from 'src/utils'
import { aosOpenApp, iosIntroDeepLink } from 'src/utils/windowOpen'
import LazyImage from 'src/components/common/LazyImage'
import React from 'react'
import {
  giftCardBannerListQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { BannerSpace } from 'src/types/api'

const GiftImgDownModal = () => {
  const { closeModal } = useModal()
  const { splashPageNav } = usePageNav()
  const os = mobileOS()

  const { data: bannerListQueryData } = useCustomQuery<BannerSpace.Response>(
    giftCardBannerListQueryOption({ Type: 2 }),
  )

  const bannerItem = bannerListQueryData?.Body?.banner?.[0]

  const openService = () => {
    const webUrl = `${process.env.REACT_APP_SERVICE_URL}/web/splash`
    switch (os) {
      case 'android':
        window.location.href = aosOpenApp(webUrl)
        break
      case 'ios':
        window.location.href = iosIntroDeepLink
        break
      default:
        closeModal().then(() => splashPageNav())
        break
    }
  }

  return (
    <S.ModalBackGroundWrap>
      <S.ModalWrap>
        <S.GiftImgDownModalContainer $option="flex_column" $row_gap="26px">
          <Typography $fontStyle={Noto_subheading_b18} color="var(--black-100)">
            이미지가 저장되었습니다.
          </Typography>
          <LazyImage
            src={bannerItem?.Image}
            style={S.BannerContents}
            onClick={() => window.open(bannerItem?.URL, '_blank')}
          />
          <Container $option="flex_column" $row_gap="12px">
            <Button option={ButtonOption7('black')} onClickFn={openService}>
              네, 지금 확인할게요
            </Button>
            <Button option={ButtonOption2('dark')} onClickFn={closeModal}>
              혜택 포기하기
            </Button>
          </Container>
        </S.GiftImgDownModalContainer>
      </S.ModalWrap>
    </S.ModalBackGroundWrap>
  )
}
export default GiftImgDownModal

const S = {
  ModalBackGroundWrap: styled.div`
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
  ModalWrap: styled.div`
    width: 100%;
    max-width: 360px;
    min-width: 280px;
    margin: 0 40px;
  `,
  GiftImgDownModalContainer: styled(Container)`
    align-items: center;
    padding: 26px 24px;
    margin-bottom: 26px;
    border-radius: 24px;
    background: var(--white);
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  `,
  BannerContents: css`
    width: 100%;
    min-height: 130px;
    height: auto;
  `,
}
